
export const mobileNumberMixins = {
	methods: {
		formatMobileNumber(value) {
			if (value) {
				let data = value.split('');
				data.splice(4, 0, '-');
				return data.join('');
			}
		}
	}
}